<template>
  <div>
    <div v-if="rawData.length === 0" style="text-align: center">
      <span class="no-data">--- Chưa có thông tin ---</span>
    </div>
    <div v-else>
      <v-row dense>
        <v-col cols="12" md="4">
          <div style="padding: 15px 30px; border: 1px solid #d2d3db; border-radius: 4px">
            <div class="mb-2" style="font-size: 18px">
              Kế hoạch GD
              <span class="px-2 py-1 white--text" style="background-color: #255cc2; border-radius: 4px">theo Lớp</span>
            </div>
            <div style="position: relative; padding: 0px 40px">
              <DoughnutChart :chartdata="chartByClass" title="lớp" />
              <div class="center-chart" v-if="chartByClass">
                <span style="font-size: 12px">Tổng số lớp</span> <br />
                <span>{{ totalClassCount }}</span>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <div style="padding: 15px 30px; border: 1px solid #d2d3db; border-radius: 4px">
            <div class="mb-2" style="font-size: 18px">
              Kế hoạch GD
              <span class="px-2 py-1 white--text" style="background-color: #255cc2; border-radius: 4px"
                >theo Bộ môn</span
              >
            </div>
            <div style="position: relative; padding: 0px 40px">
              <DoughnutChart :chartdata="chartBySubject" title="môn" />
              <div class="center-chart" v-if="chartBySubject">
                <span style="font-size: 12px">Tổng bộ môn</span><br />
                <span>{{ totalSubjectCount }}</span>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="4" v-if="!canFilterByTeacher">
          <div style="padding: 15px 30px; border: 1px solid #d2d3db; border-radius: 4px">
            <div class="mb-2" style="font-size: 18px">
              Kế hoạch GD
              <span class="px-2 py-1 white--text" style="background-color: #255cc2; border-radius: 4px"
                >theo Giáo viên</span
              >
            </div>
            <div style="position: relative; padding: 0px 40px">
              <DoughnutChart :chartdata="chartByTeacher" title="giáo viên" />
              <div class="center-chart" v-if="chartByTeacher">
                <span style="font-size: 12px">Tổng số giáo viên</span><br />
                <span>{{ totalTeacherCount }}</span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import DoughnutChart from '@/components/basic/chart/DoughnutChart.vue'
import { mapActions } from 'vuex'
import Vue from 'vue'
import { get } from 'lodash'

export default {
  props: {
    academicLevelId: {
      type: String,
      required: true,
    },
  },
  components: { DoughnutChart },
  data() {
    return {
      rawData: [],
      chartByClass: null,
      chartBySubject: null,
      chartByTeacher: null,
      totalClassCount: 0,
      totalSubjectCount: 0,
      totalTeacherCount: 0,
    }
  },
  computed: {
    canFilterByTeacher() {
      return get(this.$auth.user, 'role.type') === 'teacher'
    },
  },
  methods: {
    ...mapActions('TeachingPlan', ['getTeachingPlanForCopy']),

    async fetchData() {
      try {
        if (get(this.$auth.user, 'role.type') === 'teacher') {
          const data = await this.getTeachingPlanForCopy({
            teacher: this.$auth.user.teacher,
            academicLevel: this.academicLevelId,
            _limit: -1,
          })
          this.rawData = data
        } else {
          const data = await this.getTeachingPlanForCopy({
            academicLevel: this.academicLevelId,
            _limit: -1,
          })
          this.rawData = data
        }
        this.generateCharts()
      } catch (err) {
        this.$alert.error('Lỗi khi tải dữ liệu KHGD')
      }
    },

    generateCharts() {
      const groupByStatus = (items, keyFn) => {
        const result = {}
        for (const item of items) {
          const status = item.status || 'unknown'
          const key = keyFn(item)
          if (!key) continue
          if (!result[status]) result[status] = new Set()
          result[status].add(key)
        }
        return Object.fromEntries(Object.entries(result).map(([k, v]) => [k, v.size]))
      }

      const classData = groupByStatus(this.rawData, item => item.class && item.class._id)
      const subjectData = groupByStatus(this.rawData, item => item.subjectGroup && item.subjectGroup._id)
      const teacherData = groupByStatus(this.rawData, item => item.teacher && item.teacher._id)

      this.totalClassCount = Object.values(classData).reduce((sum, val) => sum + val, 0)
      this.totalSubjectCount = Object.values(subjectData).reduce((sum, val) => sum + val, 0)
      this.totalTeacherCount = Object.values(teacherData).reduce((sum, val) => sum + val, 0)

      const prepareChart = () => ({
        labels: [],
        datasets: [
          {
            label: '',
            backgroundColor: [],
            data: [],
          },
        ],
      })

      this.chartByClass = prepareChart()
      this.chartBySubject = prepareChart()
      this.chartByTeacher = prepareChart()

      // const fillChart = (target, dataMap) => {
      //   for (const [status, count] of Object.entries(dataMap)) {
      //     const label = `${Vue.filter('teachingPlanChartStatus')(status)}`
      //     const color = Vue.filter('teachingPlanStatusColor')(status)
      //     target.labels.push(label)
      //     target.datasets[0].data.push(count)
      //     target.datasets[0].backgroundColor.push(color)
      //   }
      // }
      const fillChart = (target, dataMap) => {
        const allStatuses = ['official', 'draft', 'unknown']
        for (const status of allStatuses) {
          const count = dataMap[status] || 0
          const label = Vue.filter('teachingPlanChartStatus')(status)
          const color = Vue.filter('teachingPlanStatusColor')(status)
          target.labels.push(label)
          target.datasets[0].data.push(count)
          target.datasets[0].backgroundColor.push(color)
        }
      }

      fillChart(this.chartByClass, classData)
      fillChart(this.chartBySubject, subjectData)
      fillChart(this.chartByTeacher, teacherData)
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>
<style>
.center-chart {
  position: absolute;
  top: 42.5%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
}
.center-chart span:last-child {
  color: #255cc2;
  font-size: 24px;
  font-weight: 500;
}
.no-data {
  font-size: 14px;
  color: #999;
}
</style>
